import {
  DataLayerAnalytics,
  User,
  UserAttributes
} from '@com-delta-idp/mnx-skymiles-landing-page-ui';

export const enum DATA_ANALYTICS {
  PAGELOAD = 'page load',
  EVENT_PAGE = 'skymiles overview',
  SYSTEMENVIRONMENT = 'responsive',
  ACCOUNTTYPE = 'accountType',
  ACCOUNT = 'account',
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  CLICK = 'click',
  CUSTOM_EVENT = 'custom event',
  ERROR_EVENT = 'error event',
  PAGELOAD_ERROR = 'page load error',
  PAGE_ERROR = 'error',
  SOURCE = 'page content',
  TILES = 'tile',
  BANNER = 'banner',
  QUICK_LINKS = 'quick links',
  OFFERS = 'offers',
  CARDS = 'cards',
  UPGRADES = 'upgrades',
  SKYCLUB_TRACKER = 'skyclub_tracker',
  MILLION_MILER = 'million miler',
  MICRO_MOMENTS = 'microMoments',
  PARTNERS = 'partners',
  AMEX_BANNER = 'amex banner',
  AWARD = 'award',
  SNAPSHOT = 'snapshot',
  MILES_AVAILABLE = 'miles available banner',
  MODAL = 'modal',
  EARNING_TITLE = 'Earning Medallion Status'
}

export const AUTHENTICATED_USER = {
  attributes: { is_logged_in: USER_LOGGED_IN_STATUS.AUTHENTICATED }
};

export const userAttributes: UserAttributes = {
  is_logged_in: 'unauthenticated'
};

export const NonLoggedInUser: User = {
  attributes: userAttributes
};

export const enum USER_LOGGED_IN_STATUS {
  UNAUTHENTICATED = 'unauthenticated',
  AUTHENTICATED = 'authenticated',
  HOT = 'hot'
}

export const enum CLICK_TYPE {
  TILE = 'tile',
  LINK = 'link'
}

export const enum EVENT_DETAIL {
  MODAL_LINK_CLICK = 'modal link click',
  TILE_CLICK = 'tile click'
}

export const DataLayerPageLoad: DataLayerAnalytics = {
  event_detail: DATA_ANALYTICS.EVENT_PAGE,
  event: DATA_ANALYTICS.PAGELOAD,
  user: {
    attributes: {
      is_logged_in: '',
      login_method: '',
      login_state: ''
    }
  },
  page: {
    info: {
      page_name: 'dal:myskymiles: overview',
      legacy_page_name: 'My Skymiles: Overview',
      page_url: '/myskymiles/overview',
      page_type: 'skymiles',
      previous_page_name: '',
      previous_page_url: '',
      section: 'skymiles',
      sub_section: 'overview',
      country: 'us',
      language: 'en',
      sys_env: 'desktop',
      page_load_time: 15
    }
  }
};

export const PageErrorData = {
  type: 'skymiles overview page load error',
  code: 'full-page',
  message: "sorry, we're currently unable to display your skymiles tracker.",
  destination_url: '/myskymiles/overview'
};

export const DataLayerEventError: DataLayerAnalytics = {
  event_detail: DATA_ANALYTICS.ERROR_EVENT,
  event: DATA_ANALYTICS.CUSTOM_EVENT,
  user: {
    attributes: {
      is_logged_in: ''
    }
  },
  error: [
    {
      type: 'load error',
      code: '402',
      message:
        "We're sorry, but we are currently unable to display the Overview page due to a technical issue. Please try again later.",
      destination_url: '/myskymiles/overview'
    }
  ]
};
